/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import AppContext from "@src/context/appContext"

const Layout = ({ children }) => (
  <AppContext.Provider value={{}}>
    <Seo />
    <Nav />
    <main>{children}</main>
  </AppContext.Provider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
